import React, { Component, Fragment } from 'react';
import { isEmpty, isEqual, cloneDeep } from 'lodash';
import { gsap } from 'gsap';
import NgGameRPGEASpices from './animations/spices';
import { SnowParticles } from '../../../snowParticles';
import { GoSnow } from '../../../snowfall3d';

import './style.css';

/* ТУТ ПО ИДЕЕ СОЧИТАЕТСЯ И ГРАФИКА И ВЫВОД И UI */

export default class NgGameRPGEffects extends Component {

    // timer;
    // tick = 0;
    // timerTime = () => {
    //     this.tick++;
    //     this.moveSnowParticles();
    // }

    snowParticlesRef = React.createRef();


    state = {
        animations: {
            // id: { id, type, node }
        },
        person1Buffs: []
    }

    person1Buffs = [];

    setPersonBuffs = ({ person1Buffs = [] }) => {
        if (!isEqual(person1Buffs, this.state.person1Buffs)) {
            this.setState({ person1Buffs: cloneDeep(person1Buffs) })
        }
    }

    componentDidMount = () => {
    }
    componentWillUnmount = () => {
    }

    deadSnowMan = ({ x, y, xForce, yForce, radius = 5, color }) => {
        const hipSq = Math.sqrt(xForce * xForce + yForce * yForce);

        const fullAngle = Math.PI * 1.5;
        const partsCunt = 40;
        const partDiff = 20;

        const thisAngle = Math.atan(yForce / xForce);
        const startAngle = thisAngle - (fullAngle / 2);
        const partes = partsCunt + Math.floor(Math.random() * partDiff)

        let nowAngle = startAngle;
        let arr = [];

        for (let i = 0; i < partes; i++) {
            nowAngle += ((fullAngle) / partes) * (0.8 + Math.random() * 0.4);
            const inlarge = 0.8 + 0.4 * Math.random();
            const locXForce = inlarge * hipSq * Math.cos(nowAngle);
            const locYForce = inlarge * hipSq * Math.sin(nowAngle);
            const ret = this.addSnowParticle({ x, y, xForce: locXForce, yForce: locYForce, radius, color })
            arr.push(ret);
        }
        this.snowParticlesRef && this.snowParticlesRef.current && this.snowParticlesRef.current.addParticles(arr);

    }

    hitOnSnowMan = ({ x, y, xForce, yForce, color }) => {
        const hipSq = Math.sqrt(xForce * xForce + yForce * yForce);

        const thisAngle = Math.atan(yForce / xForce);
        const startAngle = thisAngle - Math.PI / 6;
        const partes = 20 + Math.floor(Math.random() * 10)

        let nowAngle = startAngle;
        let arr = [];

        for (let i = 0; i < partes; i++) {
            nowAngle += ((Math.PI / 3) / partes) * (0.8 + Math.random() * 0.4);
            const inlarge = 0.8 + 0.4 * Math.random();
            const locXForce = inlarge * hipSq * Math.cos(nowAngle);
            const locYForce = inlarge * hipSq * Math.sin(nowAngle);
            const ret = this.addSnowParticle({ x, y, xForce: locXForce, yForce: locYForce, radius: 2, color })
            arr.push(ret);
        }

        this.snowParticlesRef && this.snowParticlesRef.current && this.snowParticlesRef.current.addParticles(arr);
    }

    addSnowParticle = ({ x, y, xForce, yForce, color, radius = 5 }) => {
        const lifeTime = 20 + Math.floor(Math.random() * 15);
        let colorEnd = [1, 1, 1];
        if (color === 'blue') colorEnd = [0.2, 0.2, 0.8]
        if (color === 'darkblue') colorEnd = [0.5, 0.5, 1]
        const snowParticle = {
            x,
            y,
            xForce,
            yForce,
            scale: radius,
            color: colorEnd,
            rotate: Math.floor(Math.random() * 45),
            lifeTime
        }

        return snowParticle;
    }

    render() {
        const { width, height, zIndex, noPartic } = this.props;

        // return null;

        return <div className='ngg_effects_main' style={{ zIndex, width, height }} >
            {!noPartic && <SnowParticles
                ref={this.snowParticlesRef}
                width={width}
                height={height}
                textureUrl={'https://assets.codepen.io/122136/snowflake_1.png'}
            />}
            <this.AnimationPart />
            <this.Person1Buffs />
        </div>
    }

    addAnimation = (props = []) => {
        const animations = { ...this.state.animations };
        props.forEach((val) => {
            const { type, x, y } = val;
            const { width } = this.props;
            if (!type) return;

            const id = ((Math.random() * 1000)).toFixed(0);

            if (type === 'spices') {
                const spiceWidth = width * 0.02;
                const spiceHeight = spiceWidth * 4;
                animations[id] = <NgGameRPGEASpices key={`dgdfg_${id}`} killAnimation={this.killAnimation} {...{ id, spiceWidth, spiceHeight, x, y }} />;
            }
        })
        this.setState({ animations })
    }

    killAnimation = (id) => {
        if (!this.state.animations[id]) return;
        let animations = { ...this.state.animations };
        delete animations[id];
        this.setState({ animations })
    }

    AnimationPart = () => {
        const { animations } = this.state;
        if (!animations || isEmpty(animations)) return null;

        return Object.values(animations).map((animation) => {
            return animation;
        })
    }

    // PERSON 1 BUFFS

    Person1Buffs = () => {
        const { person1Buffs } = this.state;
        if (!person1Buffs || !person1Buffs.length) return null;

        const tripleBuff = person1Buffs.find(x => x.type = 'triple')

        return <Fragment>
            {!!tripleBuff && this.TripleBuff1({ tripleBuff })}
        </Fragment>

    }

    TripleBuff1 = ({ tripleBuff }) => {
        const { width, height, zIndex } = this.props;
        const { fulled = {} } = tripleBuff;


        const aimWidth = height * 0.28 * 0.3;

        return <div className='ngg_effects_tripleBuff' style={{
            width: width * 0.1,
            height: height * 0.28,
            left: width * 0.75,
            top: height * 0.55
        }}>
            {<div style={{ width: aimWidth, height: aimWidth }} className='ngg_effects_tripleBuff_aim'>
                {!!fulled[1] && <img src={`/../images/ver2/snowman/extras/triple_aim.png`} />}
            </div>}
            {<div style={{ width: aimWidth, height: aimWidth }} className='ngg_effects_tripleBuff_aim'>
                {!!fulled[2] && <img src={`/../images/ver2/snowman/extras/triple_aim.png`} />}
            </div>}
            {<div style={{ width: aimWidth, height: aimWidth }} className='ngg_effects_tripleBuff_aim'>
                {!!fulled[3] && <img src={`/../images/ver2/snowman/extras/triple_aim.png`} />}
            </div>}
        </div>
    }

}